<template>
  <div class="message-box rounded-lg overflow-hidden shadow">
    <header class="bg-warning-dark text-white px-4 py-2 flex items-center space-x-2">
      <base-icon name="warning" />
      <h4 class="font-bold font-sans text-lg uppercase">Atención</h4>
    </header>
    <main class="leading-1 p-4 bg-warning-light text-warning-dark">
      <slot name="content" />
    </main>
  </div>
</template>

<script>
export default {
  name: 'BaseMessageBox'
}
</script>

<style lang="scss" scoped>
</style>
